<div *ngIf="!editing" [innerHTML]="display_text"></div>
<textarea (ngModelChange)="changeContent($event)"
          *ngIf="editing"
          [ngModel]="edit_text"
          rows="10" style="width:98%;margin:1%;">
</textarea>
